let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("azr0k")).then(() => parcelRequire('k36HF'));